import { adminApi } from './clients';

/**
 * The family's confirmation PDF, put right by AR: rebuilt from what is stored (the old file is
 * archived, not deleted), and emailed to the family again. Two separate requests on purpose —
 * rebuilding never emails anybody.
 */

export const regenerateConfirmation = async ({ parentId, dataLogId }) => {
    const { data } = await adminApi.post('/admin/confirmation/regenerate', { parent_id: parentId, data_log_id: dataLogId });
    return data || {};
};

export const emailConfirmation = async ({ parentId, dataLogId }) => {
    const { data } = await adminApi.post('/admin/confirmation/email', { parent_id: parentId, data_log_id: dataLogId });
    return data || {};
};
